import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: false,
  templates: []
};

const slice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getTemplatesSuccess(state, action) {
      state.isLoading = false;
      state.templates = action.payload;
    }
  }
});

export default slice.reducer;

export function getTemplates() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/template/all');
      dispatch(slice.actions.getTemplatesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
